var
    conf = require('../utils/conf'),
    symbols = require('../utils/symbols'),
    Square =  require('./Square'),
    Piece = symbols.Piece,
    Conf = conf.Conf,
    DraughtsTypes = symbols.DraughtsTypes8x8
;

function DraughtBoard(boardSize, draughtsType = DraughtsTypes.NONE) {
    this.draughtsType = draughtsType;
    this.conf = null;
    this.boardSize = boardSize;
    if (boardSize === 8){
        if (draughtsType === DraughtsTypes.ITALIAN) {
            this.conf = Conf['8x8_italian']; // Bresilien    
        } else {
            this.conf = Conf['8x8']; // Bresilien... etc
        }
    } else if (boardSize === 12){
        this.conf = Conf['12x12']; // Canadien
    } else {
        this.conf = Conf['10x10']; // Default is International 10x10
    }


    /** Active Squares */
    this.squares = []; // [Square]


    /** Initialize active squares */
    for (var k = 1; k <= this.conf['SQ_MAX_NUM']; k++) {
        var c = new Square(k);
        this.squares.push(c);
    }
}

DraughtBoard.prototype.getDraughtsType = function() {
    return this.draughtsType;
}

DraughtBoard.prototype.getBoardSize = function() {
    return this.boardSize;
}

DraughtBoard.prototype.squareMaxNum = function() {
    return this.conf['SQ_MAX_NUM'];
}

/** Initial position */
DraughtBoard.prototype.setInitialPosition = function() {
    for (let num = this.conf['B_POSITION'][0]; num <= this.conf['B_POSITION'][1]; num++) {
        this.setPiece(Piece.PAWN_BLACK, num);
    }

    for (let num = this.conf['W_POSITION'][0]; num <= this.conf['W_POSITION'][1]; num++) {
        this.setPiece(Piece.PAWN_WHITE, num);
    }
    return this;
};

/** Pose des pièces sur le damier */
DraughtBoard.prototype.setPosition = function(piece, numbers) {
    for (var k = 0; k < numbers.length; k++) {
        this.setPiece(piece, numbers[k]);
    }
    return this;
};

/** Ajouter une pièce sur une case. */
DraughtBoard.prototype.setPiece = function(piece, number) {
    var c = this.getSquare(number);
    c.piece = piece;
    return this;
};

/** Retourne une case. */
DraughtBoard.prototype.getSquare = function(number) {
    return this.squares[number - 1];
};

/** Retourne une case. */
DraughtBoard.prototype.getSquares = function() {
    return this.squares;
};

/** Connaitre la pièce se trouvant sur une case. */
DraughtBoard.prototype.isPiece = function(piece, number) {
    return (this.getPiece(number) === piece);
};

DraughtBoard.prototype.isSquareEmpty = function(number) {
    return this.getSquare(number).piece === Piece.EMPTY;
};

/** Retourne la pièce. */
DraughtBoard.prototype.getPiece = function(number) {
    return this.getSquare(number).piece;
};

DraughtBoard.prototype.getColor = function(number) {
    return this.getSquare(number).getColor();
};


/** Applique le mouvement sur le damier. */
DraughtBoard.prototype.applyMove = function(move) {
    var piecePlayed = this.getPiece(move.startingSquareNum);

    // Retirer la pièce de la case de départ
    this.setPiece(Piece.EMPTY, move.startingSquareNum);

    // Retirer les pièces des cases prises
    for (var i = 0; i < move.capturedSquares.length; i++) {
        var c = move.capturedSquares[i];
        this.setPiece(Piece.EMPTY, c.number);
    }

    // Poser la pièce sur la case d'arrivée
    if (!move.isCrowned) {
        this.setPiece(piecePlayed, move.endingSquareNum);
    }
    // Ce mouvement promeu en Dame
    else {
        if (piecePlayed === Piece.PAWN_WHITE) {
            this.setPiece(Piece.DAME_WHITE, move.endingSquareNum);
        } else if (piecePlayed === Piece.PAWN_BLACK) {
            this.setPiece(Piece.DAME_BLACK, move.endingSquareNum);
        }
    }
    return this;
};

/** Annule le mouvement sur le damier. */
DraughtBoard.prototype.applyMoveRev = function(move) {
    var piecePlayed = this.getPiece(move.endingSquareNum);

    // Retirer la pièce de la case d'arrivée
    this.setPiece(Piece.EMPTY, move.endingSquareNum);

    // Remettre les pièces qui avaient été prises.
    for (var i = 0; i < move.capturedSquares.length; i++) {
        var c = move.capturedSquares[i];
        this.setPiece(c.piece, c.number);
    }

    // Remettre la pièce sur la case de départ
    if (!move.isCrowned) {
        this.setPiece(piecePlayed, move.startingSquareNum);
    }

    // La dame redevient pion
    else {
        if (piecePlayed === Piece.DAME_WHITE) {
            this.setPiece(Piece.PAWN_WHITE, move.startingSquareNum);
        } else if (piecePlayed === Piece.DAME_BLACK) {
            this.setPiece(Piece.PAWN_BLACK, move.startingSquareNum);
        }
    }
    return this;
};

DraughtBoard.prototype.debugDraughtBoard = function() {
    var row = "";

    console.log("================================");
    for (var k = 0; k < 10; k++) {
        row += "|";
        for (var l = 1; l <= 5; l++) {

            var num = 5 * k + l;
            var p = this.getSquare(num).piece;

            if (k === 0 || k === 2 || k === 4 || k === 6 || k === 8) {
                row += "   ";
            }

            switch (p) {
            case Piece.PAWN_WHITE:
                row += " o ";
                break;
            case Piece.PAWN_BLACK:
                row += " x ";
                break;
            case Piece.DAME_WHITE:
                row += " O ";
                break;
            case Piece.DAME_BLACK:
                row += " X ";
                break;
            default:
                row += " . ";
            }

            if (k === 1 || k === 3 || k === 5 || k === 7 || k === 9) {
                row += "   ";
            }
        }
        row += "|";

        console.log(row);
        row = "";
    }
    console.log("================================");
};

DraughtBoard.prototype.checkIsPromoteField = function(piece, squareNum) {
    let result = false;
    if (piece === Piece.PAWN_BLACK) {
        result = (squareNum >= this.conf['B_CROWNED'][0] && squareNum <= this.conf['B_CROWNED'][1]);
    }
    if (piece === Piece.PAWN_WHITE) {
        result = (squareNum >= this.conf['W_CROWNED'][0] && squareNum <= this.conf['W_CROWNED'][1]);
    }
    return result;
}

DraughtBoard.prototype.checkIsPromoteInWay = function(piece, listOfSquares) {
    let result = false;
    for (let squareKey in listOfSquares) {
        const square = listOfSquares[squareKey];
        if (!result) {
            result = this.checkIsPromoteField(piece, square);
        }
    }
    return result;
}

DraughtBoard.prototype.clone = function() {
    let d = new DraughtBoard(this.getBoardSize(), this.getDraughtsType());

    for (let k = 0; k < this.getSquares().length; k++) {
        let c = this.getSquare(k + 1);
        d.setPiece(c.piece, c.number);
    }

    return d;
};

module.exports = DraughtBoard;



// WEBPACK FOOTER //
// ./src/board/core/DraughtBoard.js